import './offer-detail.scss';

import {
      OFFERID_QUERY_PARAM,
      DEALERID_QUERY_PARAM,
      MEDIAQUERY_SMALL,
      MEDIAQUERY_MEDIUM,
      MEDIAQUERY_LARGE,
      MEDIAQUERY_XLARGE,
      INTERPOLATION_REGEX,
      OFFER_MODELID_QUERY_PARAM,
    } from '../../core/constants'; // eslint-disable-line max-len
import {
      openOfferDetails,
      closeOfferDetails,
    } from '../../core/actions/offers';
import {
      addParamToURL,
      findParam,
      replaceParamOnURL,
    } from '../../core/queryParams';
import { getCurrentOffer } from '../../core/selectors/offers';
riot.tag2('offer-detail', '<div class="offer-detail-carat" riot-style="left: {caratPosition}px"></div> <offer-detail-container opened="{isOpen}" offer="{currentOffer}"></offer-detail-container>', '', 'class="offer-detail {\'is-open\': isOpen}" riot-style="order: {order}"', function(opts) {

    const itemSelector = '.offer-detail-item';
    const self = this;
    const $parent = self.parent.root;
    let $boxes;
    let lastBox;
    let $box;

    self.mixin('redux');

    self.dispatchify({ closeOfferDetails });
    self.dispatchify({ openOfferDetails });

    self.subscribe(getCurrentOffer);

    self.order = 0;
    self.isOpen = false;
    self.caratPosition = 0;

    function closeDetails() {
      self.isOpen = false;

      self.update();
    }

    function getParent(element, selector) {
      const firstChar = selector.charAt(0);

      for (; element && element !== document; element = element.parentNode) {
        if (firstChar === '.') {
          if (element.classList.contains(selector.substr(1))) {
            return element;
          }
        }
      }
      return false;
    }

    function insertParam(url, key, value) {
      let newUrl;
      const kvp = url.indexOf('?');

      key = escape(key);
      value = escape(value);

      if (kvp > 0) {
        newUrl = `${url}&${key}=${value}`;
      } else {
        newUrl = `${url}?${key}=${value}`;
      }

      return newUrl;
    }

    function getURL(url, offer) {
      const replacements = url.match(INTERPOLATION_REGEX);
      const dataObj = offer;
      dataObj.dealerid = findParam(DEALERID_QUERY_PARAM) || '';

      if (replacements) {
        replacements.forEach((match) => {
          url = url.replace(match, dataObj[match.slice(3, -3)].replace(' ', '-') || '');
        });
      }

      if (offer.ModelId) {
        url = insertParam(url, OFFER_MODELID_QUERY_PARAM, offer.ModelId);
      }

      return url;
    }

    function openDetails(data) {
      if (data.event && data.event.preventDefault) {
        data.event.preventDefault();
      }

      $box = getParent(document.querySelector(`#${data.id}`), itemSelector);
      const boxType = $box.getAttribute('offer-detail-id');
      const offer = data.event && data.event.item && data.event.item.offer
        ? data.event.item.offer : self.currentOffer;
      const queryOfferid = findParam(OFFERID_QUERY_PARAM);
      const offerId = data.id.split('_')[1];

      // Opening on a modal when the offer is any special type but HCPD (ASO-17450)
      if (self.opts.type === boxType && offer && self.specialTypes.indexOf(data.event.item.offer.SalesProgramType) !== -1) {
        let url = self.ctas.offerCardSpecialDetails ? self.ctas.offerCardSpecialDetails[0].url : null;

        let newURL;

        if (queryOfferid) {
          newURL = replaceParamOnURL(OFFERID_QUERY_PARAM, offerId);
        } else {
          newURL = addParamToURL(OFFERID_QUERY_PARAM, offerId);
        }

        window.history.pushState({}, '', newURL);

        url = getURL(url, {
          OfferId: offerId || data.event.item.offer.Id,
          ModelId: data.event.item.offer.ModelId,
        });

        self.bus.trigger(self.bus.EVENTS.CARD.VIEW_SPECIAL_OFFER_DETAIL, {
          url,
          event: data.event,
          offer: data.event.item.offer,
        });

        closeDetails();

        return;
      }

      const $carat = self.root.querySelector('.offer-detail-carat');
      const $button = $box.querySelector('.offer-card-link');
      const breakpoints = [
        {
          matchMedia: window.matchMedia(MEDIAQUERY_SMALL),
        },
        {
          matchMedia: window.matchMedia(MEDIAQUERY_MEDIUM),
        },
        {
          matchMedia: window.matchMedia(MEDIAQUERY_LARGE),
        },
        {
          matchMedia: window.matchMedia(MEDIAQUERY_XLARGE),
        },
      ];
      let groupCount = 0; // total offer-detail-item per row
      let url = '';

      self.order = 0;

      self.currentOffer = data.event && data.event.item && data.event.item.offer ? data.event.item.offer : self.currentOffer;

      if (self.opts.type === boxType) {
        $boxes = [...$parent.querySelectorAll(itemSelector)];

        if (queryOfferid) {
          url = replaceParamOnURL(OFFERID_QUERY_PARAM, offerId);
        } else {
          url = addParamToURL(OFFERID_QUERY_PARAM, offerId);
        }

        window.history.pushState({}, '', url);

        groupCount = $boxes.reduce((prev, $current) => {
          const currentOrder = $current.style.order;

          if ($current.getBoundingClientRect().top === $box.getBoundingClientRect().top) {
            return (prev >= currentOrder) ? prev : currentOrder;
          }

          return prev;
        }, 0);

        self.order = groupCount;
        self.isOpen = (data.id === lastBox) ? !self.isOpen : true;

        if (!self.isOpen) {
          $button.classList.add('show-details');
          $button.classList.remove('hide-details');
          self.closeOfferDetails({ offerId: self.currentOffer.Id });
          $button.innerText = self.getLabel('labels.card.offerDetailsLink');
        } else {
          self.openOfferDetails({ offerId: self.currentOffer.Id });
          $button.innerText = self.getLabel('labels.card.offerCloseDetailsLink');
          $button.classList.add('hide-details');
          $button.classList.remove('show-details');
        }

        self.update();

        if (self.opts.featuredSingle) {
          self.caratPosition = parseInt(window.getComputedStyle($box).paddingLeft, 10)
                                + (parseInt(window.getComputedStyle($box).width, 10) / 2);
        } else {
          self.caratPosition = ($box.getBoundingClientRect().left - $box.offsetParent.offsetLeft)
            + (($box.getBoundingClientRect().width / 2) - ($carat.getBoundingClientRect().width / 2));
        }

        lastBox = data.id;

        breakpoints.forEach((breakpoint) => {
          breakpoint.matchMedia.addListener((mediaQuery) => {
            if (mediaQuery.matches) {
              openDetails(data, true);
            }
          });
        });
      } else {
        const $buttons = [...document.querySelectorAll('.offer-card-link')];
        $buttons.forEach(($currentButton) => {
          if ($button !== $currentButton) {
            $currentButton.innerText = self.getLabel('labels.card.offerDetailsLink');
          }
        });
        self.isOpen = false;
      }

      self.update();
    }

    function checkCaratPosition() {
      if (self.isOpen) {
        const $carat = self.root.querySelector('.offer-detail-carat');

        if (self.opts.featuredSingle) {
          self.caratPosition = parseInt(window.getComputedStyle($box).paddingLeft, 10)
                                + (parseInt(window.getComputedStyle($box).width, 10) / 2);
        } else {
          self.caratPosition = ($box.getBoundingClientRect().left - $box.offsetParent.offsetLeft)
            + (($box.getBoundingClientRect().width / 2) - ($carat.getBoundingClientRect().width / 2));
        }

        self.update();
      }
    }

    self.closeDetails = closeDetails;

    self.mixin('bus');

    self.bus.on(self.bus.EVENTS.OFFER_CARD.LINK_CLICK, openDetails);
    self.bus.on(self.bus.EVENTS.LEASE.LEASE_PAYMENT_CHANGE, closeDetails);
    self.bus.on(self.bus.EVENTS.MODEL.CHANGE, closeDetails);
    self.bus.on(self.bus.EVENTS.ZIPCODE.UPDATE, closeDetails);
    self.bus.on(self.bus.EVENTS.APP.RESIZE, checkCaratPosition);
});
